
import { prop, Vue } from "vue-class-component";
import { RegularTimeSlot } from "./schedule-types";

class Props {
  timeSlot = prop<RegularTimeSlot>({ required: true, type: Object });
  removable = prop<boolean>({ default: true, type: Boolean });
  disabled = prop<boolean>({ default: false, type: Boolean });
}

export default class TimeSlotChip extends Vue.with(Props) {}
